module.exports = __webpack_public_path__ + "static/media/sopt16kz.9f831827.pdf";